import { FC, useState } from 'react';

import { StatusPopup } from '../../atoms';
import { CustomModal } from '../../molecules';
import { ShareBySMSMGP as ShareBySMS } from '../ShareBySms';
import { ShareByEmailMGP as ShareByEmail } from '../ShareByEmail';
import { ShareReservationProps } from './ShareReservationModal.types';

import { constants, TRACKING_CONSTANT } from '../../constants';
import { getClickTrackValue } from '../../utils';

export const ShareReservationModalMGP: FC<ShareReservationProps> = props => {
  const { SUCCESS } = constants;
  const { RESCONFO_TILE, INTERNAL_LINK } = TRACKING_CONSTANT;
  const { openShareModal, setopenShareModal, shareProps, successTitle, successSubTitle, errorTitle, errorSubTitle } =
    props;
  const { shareByEmail, shareByText, title, required } = shareProps;

  const [stepType, setStepType] = useState<string>('');
  const [status, setStatus] = useState<string>('');
  const clickTrackValue = getClickTrackValue('', props?.trackingProperties) || `${RESCONFO_TILE}|`;

  const ShareResOptions = [];

  if (!shareByEmail.disableShareByEmail) {
    ShareResOptions.push({
      key: 'email',
      iconClass: 'icon-mail',
      title: shareByEmail.text,
      buttonClass: 'icon-arrow-right',
      clickTrackValue: `${clickTrackValue}${shareByEmail.text}|${INTERNAL_LINK}`,
    });
  }
  if (!shareByText.disableShareByText) {
    ShareResOptions.push({
      key: 'message',
      iconClass: 'icon-messenger',
      title: shareByText.text,
      buttonClass: 'icon-arrow-right',
      clickTrackValue: `${clickTrackValue}${shareByText.text}|${INTERNAL_LINK}`,
    });
  }

  const handleClick = (key: string) => {
    setStepType(key);
  };

  const handleClose = () => {
    if (status && status?.toLocaleLowerCase() !== SUCCESS) {
      setStatus('');
    } else {
      setopenShareModal(false);
      setStepType('');
      setStatus('');
    }
  };

  const stepHeading = () => {
    return stepType === 'email' ? shareByEmail.text : shareByText.text;
  };

  const renderChildren = () => {
    if (stepType === 'email' && !status) {
      return (
        <ShareByEmail
          {...shareByEmail}
          required={required}
          setShowStatusPopup={(statusValue: string) => setStatus(statusValue)}
        />
      );
    } else if (status?.toLocaleLowerCase() === SUCCESS) {
      return <StatusPopup type={status?.toLocaleLowerCase()} title={successTitle} subTitle={successSubTitle} />;
    } else if (status) {
      return <StatusPopup type={status} title={errorTitle} subTitle={errorSubTitle} />;
    }
    return (
      <ShareBySMS
        {...shareByText}
        required={required}
        setShowStatusPopup={(statusValue: string) => setStatus(statusValue)}
      />
    );
  };

  return (
    <div data-component-name="o-book-ShareReservationModal" data-testid="ShareReservationModal">
      <CustomModal
        openModal={openShareModal}
        optionsList={ShareResOptions}
        showHeader={!status}
        heading={stepType ? stepHeading() : title}
        backArrow={Boolean(stepType)}
        handleBackButton={() => setStepType('')}
        handleClose={handleClose}
        handleListClick={handleClick}
        optionsModal={Boolean(!stepType)}
        children={renderChildren()}
        isShareEmail={stepType === 'email'}
        ariaDescribedby="share-reservation"
      />
    </div>
  );
};
